import React from 'react'
import { useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './ShipPayments.css'
import { useTranslation } from "react-i18next";
import { fetchShipPayments } from '../../../utils/apiClient';

/**
 * 送料決済（発送依頼時の配送費支払い）一覧画面。
 * shipments（v2 決済フロー・確定済み）を決済方法（ポイント/現金/併用）別に絞り込み、
 * 決済番号 / 注文番号 / ユーザーID で検索する。一覧は最新200件まで（サーバ側 limit）。
 */
const ShipPayments = () => {
  const { t } = useTranslation();

  const [list, setList] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [cashTotal, setCashTotal] = React.useState(0);
  const [ptTotal, setPtTotal] = React.useState(0);
  const [message, setMessage] = React.useState(null);

  const [method, setMethod] = React.useState('');
  const [orderNo, setOrderNo] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [wechatTxId, setWechatTxId] = React.useState('');

  useEffect(() => {
    const api = () => {
      const params = new URLSearchParams();
      if (method) params.append('payment_method', method);
      if (orderNo) params.append('order_no', orderNo);
      if (userId) params.append('user_id', userId);
      if (wechatTxId) params.append('wechat_transaction_id', wechatTxId);
      // 件数・合計は重い集計になるため、個別検索中は算出しない（広い一覧表示時のみ取得）
      const broad = !orderNo && !userId && !wechatTxId;
      if (broad) params.append('include_totals', '1');

      fetchShipPayments(params.toString())
        .then(async response => {
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            alert(data.message || t('common.error'));
            return;
          }
          if (data?.errors) {
            alert(Object.values(data.errors)[0]);
            return;
          }
          setList(data?.data || []);
          setCount(data?.meta?.count ?? (data?.data?.length || 0));
          // 合計は opt-in（広い一覧時のみ返る）。来ない時は前回値を保持
          if (data?.meta?.cash_total_cny !== undefined) {
            setCashTotal(data.meta.cash_total_cny);
          }
          if (data?.meta?.pt_total !== undefined) {
            setPtTotal(data.meta.pt_total);
          }
          setMessage(data?.meta?.message || null);
        })
        .catch(error => {
          console.error(error);
        });
    }

    const timer = setTimeout(() => { api(); }, 400)
    return () => clearTimeout(timer)
  }, [method, orderNo, userId, wechatTxId]);

  const CreateList = () => {
    return list.map((sp, index) => <Tr key={index} sp={sp} />)
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="ship-payments">
        <div className="ship-payments-title">{t('ship_payments.title')}</div>
        <div className='clearfix'></div>

        <div className="ship-payments-search">
          <table className="ship-payments-search-table">
            <tbody>
              <tr>
                <td>
                  <select className="ship-payments-search-input" value={method} onChange={(e) => setMethod(e.target.value)}>
                    <option value="">{t('ship_payments.method_all')}</option>
                    <option value="points_only">{t('ship_payments.method_points_only')}</option>
                    <option value="cash_only">{t('ship_payments.method_cash_only')}</option>
                    <option value="mixed">{t('ship_payments.method_mixed')}</option>
                  </select>
                </td>
                <td>
                  <input className="ship-payments-search-input" type="text" placeholder={t('ship_payments.order_no')} value={orderNo} onChange={(e) => setOrderNo(e.target.value)} />
                </td>
                <td>
                  <input className="ship-payments-search-input" type="text" placeholder={t('ship_payments.user_id')} value={userId} onChange={(e) => setUserId(e.target.value)} />
                </td>
                <td>
                  <input className="ship-payments-search-input" type="text" placeholder={t('ship_payments.wechat_transaction_id')} value={wechatTxId} onChange={(e) => setWechatTxId(e.target.value)} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="ship-payments-summary">
            <span>{t('ship_payments.count')}: {count}</span>
            <span>{t('ship_payments.cash_total')}: {cashTotal}</span>
            <span>{t('ship_payments.pt_total')}: {ptTotal}</span>
          </div>
          {message && <div className="ship-payments-message">{message}</div>}
        </div>

        <div className="ship-payments-content">
          <table className="ship-payments-content-table">
            <thead>
              <tr>
                <th>{t('ship_payments.order_no')}</th>
                <th>{t('ship_payments.user_id')}</th>
                <th>{t('ship_payments.method')}</th>
                <th>{t('ship_payments.consumed_pt')}</th>
                <th>{t('ship_payments.cash_paid_cny')}</th>
                <th>{t('ship_payments.wechat_transaction_id')}</th>
                <th>{t('ship_payments.created_at')}</th>
              </tr>
            </thead>
            <tbody>
              <CreateList />
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default ShipPayments
